export default "__VITE_ASSET__Cl72Ooti__"